module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "loader"
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('component-header'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('section', {
    staticClass: "padding-top-10 padding-bottom-100 pages-in chart-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-sm-12 shopping-cart text-center"
  }, _vm._l((_vm.sorted_cart), function(group, index) {
    return _c('div', {
      staticClass: "row group-row",
      staticStyle: {
        "margin-bottom": "6em"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index == 0),
        expression: "index == 0"
      }]
    }, [_c('h5', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(group[0]) + "'s Sellpoint")]), _c('br'), _vm._v(" "), _vm._l((group[1]), function(item, index2) {
      return _c('ul', {
        staticClass: "row cart-details"
      }, [_c('li', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('a', {
        staticClass: "item-img cart-img",
        staticStyle: {
          "cursor": "pointer"
        },
        attrs: {
          "href": item.product_url
        }
      }, [_c('img', {
        attrs: {
          "src": _vm.img_product_url + item.product_item_image,
          "alt": ""
        }
      })])]), _vm._v(" "), _c('div', {
        staticClass: "col-md-6 col-sm-12"
      }, [_c('h5', [_vm._v(_vm._s(item.product_name))]), _vm._v(" "), (item.product_checked) ? _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.removeFromCheckout(item, index, index2)
          }
        }
      }, [_c('del', [_vm._v("Selected")])]) : _c('button', {
        staticClass: "btn order-btn",
        on: {
          "click": function($event) {
            _vm.addToCheckout(item, index, index2)
          }
        }
      }, [_vm._v("Select Order")])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', [_vm._v("Price: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [_c('div', {}, [_c('div', {
        staticClass: "quinty"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (item.product_item_order_quantity),
          expression: "item.product_item_order_quantity"
        }],
        staticStyle: {
          "max-width": "52px",
          "max-height": "32px"
        },
        attrs: {
          "type": "number"
        },
        domProps: {
          "value": (item.product_item_order_quantity)
        },
        on: {
          "change": function($event) {
            _vm.refreshCheckout(item, index, index2)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            item.product_item_order_quantity = $event.target.value
          }
        }
      })])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-2"
      }, [_c('div', {}, [_c('label', [_vm._v("Total: ")]), _vm._v(" "), _c('span', {
        staticClass: "price"
      }, [_c('small', [_vm._v("₦")]), _vm._v(_vm._s(item.product_item_order_quantity * item.product_item_price))])])]), _vm._v(" "), _c('li', {
        staticClass: "col-sm-1"
      }, [(item.can_remove) ? _c('div', {}, [_c('label', [_vm._v("Remove: ")]), _vm._v(" "), _c('a', {
        staticStyle: {
          "cursor": "pointer"
        },
        on: {
          "click": function($event) {
            _vm.removeFromCart(item._id, index, item)
          }
        }
      }, [_c('i', {
        staticClass: "icon-close"
      })])]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }), _vm._v(" "), _c('div', [(item.has_delivery) ? _c('p', {
        staticStyle: {
          "color": "#ff0000"
        }
      }, [_vm._v("\r\n                        This product has specific delivery options,\r\n                        "), _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#0c0c0c",
          "font-weight": "bolder"
        },
        on: {
          "click": function($event) {
            _vm.toggleProductDelivery('item-delivery-options', index, index2)
          }
        }
      }, [_vm._v("SELECT")]), _vm._v(" "), (item.display_delivery_details) ? _c('a', {
        staticStyle: {
          "cursor": "pointer",
          "color": "#ff0000",
          "font-size": "10px"
        },
        on: {
          "click": function($event) {
            _vm.toggleProductDelivery('hide-item-delivery-options', index, index2)
          }
        }
      }, [_vm._v(" / HIDE")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.display_delivery_details) ? _c('div', _vm._l((group[2]), function(option) {
        return _c('div', {
          staticClass: "row"
        }, [(option.business_delivery_product == item.product_main_id) ? _c('span', [_c('label', [(item.product_checked) ? _c('span', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.delivery_fee),
            expression: "delivery_fee"
          }],
          attrs: {
            "type": "radio"
          },
          domProps: {
            "value": option.business_delivery_option_id,
            "checked": _vm._q(_vm.delivery_fee, option.business_delivery_option_id)
          },
          on: {
            "click": function($event) {
              _vm.calc_product_delivery_fee(index, option, index2)
            },
            "__c": function($event) {
              _vm.delivery_fee = option.business_delivery_option_id
            }
          }
        })]) : _vm._e(), _vm._v("\r\n                              " + _vm._s(option.business_delivery_option) + " - " + _vm._s(option.business_delivery_option_price) + "\r\n                            ")])]) : _vm._e()])
      })) : _vm._e()])])
    }), _vm._v(" "), (group.items_in_checkout > 0) ? _c('div', [(group[4]) ? _c('div', {
      staticClass: "pull-left coupons-sec"
    }, [_vm._m(3, true), _vm._v(" "), _vm._m(4, true), _vm._v(" "), _vm._l((group[4]), function(coupon) {
      return _c('p', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.coupon_code),
          expression: "coupon_code"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": coupon.discount_id,
          "checked": Array.isArray(_vm.coupon_code) ? _vm._i(_vm.coupon_code, coupon.discount_id) > -1 : (_vm.coupon_code)
        },
        on: {
          "click": function($event) {
            _vm.set_coupons(index, coupon, coupon.discount_percentage)
          },
          "__c": function($event) {
            var $$a = _vm.coupon_code,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = coupon.discount_id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.coupon_code = $$a.concat($$v))
              } else {
                $$i > -1 && (_vm.coupon_code = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.coupon_code = $$c
            }
          }
        }
      }), _vm._v(" " + _vm._s(coupon.discount_coupon_code) + " - " + _vm._s(coupon.discount_percentage) + "% Off "), _c('b', [_vm._v("From " + _vm._s(coupon.discount_provider))])])
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "pull-right delivery-sec"
    }, [(group.products_without_delivery_details_count >= 1) ? _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(group[0]))]), _vm._v(" Sellpoint Delivery")]), _vm._v(" "), (group[2] && !group.delivery_option) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "14px"
      }
    }, [_vm._v("Please select a delivery option"), _c('br')]) : _vm._e(), _vm._v(" "), (group[2]) ? _c('div', {
      staticStyle: {
        "height": "5em",
        "overflow": "auto"
      }
    }, _vm._l((group[2]), function(option) {
      return _c('div', [(option.business_delivery_product == 0) ? _c('span', [_c('label', [((group.items_in_checkout > 0) && (group.products_without_delivery_details_checked.length > 0)) ? _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.delivery_fee),
          expression: "delivery_fee"
        }],
        attrs: {
          "type": "radio"
        },
        domProps: {
          "value": option.business_delivery_option_id,
          "checked": _vm._q(_vm.delivery_fee, option.business_delivery_option_id)
        },
        on: {
          "click": function($event) {
            _vm.calc_sellpoint_delivery_fee(index, option)
          },
          "__c": function($event) {
            _vm.delivery_fee = option.business_delivery_option_id
          }
        }
      })]) : _vm._e(), _vm._v("\r\n                                " + _vm._s(option.business_delivery_option) + " -  ₦" + _vm._s(option.business_delivery_option_price) + "\r\n                              ")])]) : _vm._e()])
    })) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [_c('p', [_vm._v("Total Orders from "), _c('b', [_vm._v(_vm._s(group[0]) + ":")]), _vm._v(" ₦" + _vm._s(group.total_order_amt))]), _vm._v(" "), (group[2]) ? _c('span', [_c('p', [_vm._v("Shipping Fee:  ₦" + _vm._s(group.total_delivery_charge))]), _vm._v(" "), _c('p', [_vm._v("Total: ₦" + _vm._s(group.total_order_amt + group.total_delivery_charge))])]) : _c('span', [_c('p', [_c('b', [_vm._v("Shipping Details:")]), _vm._v(" " + _vm._s(group.delivery_option))])]), _vm._v(" "), (group[3]) ? _c('div', {
      staticClass: "row"
    }, [_vm._m(5, true), _vm._v(" "), (!group.payment_mode) ? _c('span', {
      staticStyle: {
        "color": "#ff0000",
        "font-size": "14px"
      }
    }, [_vm._v("Please select a payment option"), _c('br')]) : _vm._e(), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_on_delivrey"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_on_delivrey")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 2)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_on_delivrey"
        }
      }
    }), _c('label', [_vm._v("Pay On Delivery")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.payment_option),
        expression: "payment_option"
      }],
      attrs: {
        "type": "radio",
        "value": "pay_now"
      },
      domProps: {
        "checked": _vm._q(_vm.payment_option, "pay_now")
      },
      on: {
        "click": function($event) {
          _vm.setPaymentOption(index, 1)
        },
        "__c": function($event) {
          _vm.payment_option = "pay_now"
        }
      }
    }), _c('label', [_vm._v("Pay Now")])]) : _c('div', {
      staticClass: "row"
    }, [_vm._m(6, true)])])])], 2)])
  })), _vm._v(" "), (_vm.checked_out.length != 0) ? _c('div', {
    staticClass: "orders-panel pull-right",
    staticStyle: {
      "margin-bottom": "2em"
    }
  }, [_c('span', {
    staticClass: "col-sm-12"
  }, [_c('p', [_c('b', [_vm._v("Total Order: ")]), _vm._v("₦" + _vm._s(_vm.total_order_amt + _vm.total_delivery_fee))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.process_orders()
      }
    }
  }, [_vm._v("Process Orders")])])]) : _vm._e()])]), _vm._v(" "), _c('component-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-center-center"
  }, [_c('div', {
    staticClass: "ldr"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12"
  }, [_c('span', {
    staticClass: "pull-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/sp-truck.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 chart-card"
  }, [_c('h1', {
    staticClass: "cart-title"
  }, [_vm._v("Process Your Orders")]), _vm._v(" "), _c('p', [_vm._v("Please select your Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Applied Coupons")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "14px"
    }
  }, [_vm._v("Please select coupons"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Payment Mode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Payment Mode: "), _c('span', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("Pay Now")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d2b5c94"}!./src/pages/Order/template.html
// module id = 259
// module chunks = 0